import React from 'react'
import Login from './Login'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import AlertContainer from 'react-alert'
import { authenticate } from '../../api/users'

class LoginContainer extends React.PureComponent {
  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'dark',
    time: 5000,
    transition: 'scale'
  }

  constructor (props, context) {
    super(props, context)

    this.state = {
      redirectToReferrer: false
    }
  }

  onEmailChange = (event) => {
    this.setState({ email: event.target.value })
  }

  onPasswordChange = (event) => {
    this.setState({ password: event.target.value })
  }

  login = (event) => {
    authenticate(this.state.email, this.state.password).then(data => {
      this.props.onLogin(data.user, data.token)
      this.setState({ redirectToReferrer: true })
    }, (err) => {
      if (err) {
        this.msg.show('Invalid email/password combination', {
          time: 4000,
          type: 'error'
        })
      }
    })
    event.preventDefault()
  }

  render () {
    const { from } = (this.props.location && this.props.location.state) || { from: { pathname: '/' } }

    if (this.state.redirectToReferrer) {
      return <Redirect to={from} />
    }

    return <div>
      <Login onEmailChange={this.onEmailChange} onPasswordChange={this.onPasswordChange} onSubmit={this.login} />
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

LoginContainer.propTypes = {
  onLogin: PropTypes.func,
  location: PropTypes.object
}

export default LoginContainer



// WEBPACK FOOTER //
// ./src/pages/Login/LoginContainer.js